var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',{attrs:{"col":"12","sm":"6","lg":"4"},on:{"click":function($event){return _vm.$router.push({ path: 'wfh' })}}},[_c('CWidgetIcon',{attrs:{"header":"","text":"ลงเวลาปฏิบัติงาน","color":"gradient-info","icon-padding":false,"link":"wfh"}},[_c('CIcon',{staticClass:"mx-5",attrs:{"name":"cil-laptop","width":"24"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }